import moment from 'moment-timezone'

import isCredibleDate from '../is-credible-date'

const DateFormatter = {
  format: (date, { defaultText, inputFormat, outputFormat = 'MMM DD, YYYY' } = {}) => {
    if (!isCredibleDate(date)) {
      return defaultText
    }
    return moment(date, inputFormat).format(outputFormat)
  },
}

export default DateFormatter
